<template>
  <div>
    <alert-message-modal></alert-message-modal>
    <Navigation active="plantBatches"></Navigation>
    <div class="row">
      <div class="col-12 table-overlay">
        <div class="block">
          <div v-if="showLoader" class="overlay"></div>
          <hash-loader v-if="showLoader" class="hash-icon table-hash-icon" color="#9eb89f" loading="loading" size="40" sizeUnit="px"></hash-loader>
          <div class="block-header bg-light">
            <h3 class="block-title text-white"><i class="fa fa-object-group"></i> Complete List of Plant batches</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option text-white" @click.prevent="showAddPlantBatchModal()">
                <i v-bind:disabled="showLoader" class="si si-plus"></i> Create new plant batch
              </button>
            </div>
          </div>
          <div class="block-content block-content-full table-overview">
          <table id="plantbatch-table" class="table table-bordered table-striped table-vcenter js-dataTable-full js-table-checkable">
            <thead>
              <tr>
                <th class="text-center">ID</th>
                <th class="text-center">Name</th>
                <th class="text-center">Type</th>
                <th class="text-center">Strain</th>
                <th class="text-center">Planted Date</th>
                <th class="text-center no-sorting">Advance</th>
              </tr>
            </thead>
            <tbody>{{ getBatchEntries }}
              <tr v-for="(plantbatch, index) in plantBatches" :key="index">
                <td class="text-center font-size-sm">{{ plantbatch.Id }}</td>
                <td class="font-w600 font-size-sm text-center">
                    <router-link :to="`/plantbatch/details/${plantbatch.Id}`">{{ plantbatch.Name }}</router-link>
                </td>
                <td class="text-center">{{ plantbatch.Type }}</td>
                <td class="text-center text-break">{{ plantbatch.StrainName }}</td>
                <td class="font-size-sm text-center">
                  <em class="text-muted text-center">{{ plantbatch.PlantedDate }}</em>
                </td>
                <td class="text-center">
                  <button class="btn bg-light text-white" title="Add New Plant" @click.prevent="showAddPlantModal(plantbatch.Name)">
                    <i class="si si-plus"></i> Add New Plant
                  </button>
                  <button class="btn bg-light" title="Create Package" @click.prevent="showCreatePackageModal(plantbatch)">
                    <i class="fa fa-box-open text-muted text-white"></i>
                  </button>
                  <button class="btn btn-danger" title="Destroy" @click.prevent="showDestroyModal(plantbatch.Name)">
                    <i class="fa fa-times text-white"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        </div>
      </div>
    </div>

    <!--Begin add-new-plant modal window-->
    <AddPlant ref="addPlant" @showSuccessMsg="displaySuccessMsg"></AddPlant>
    <!--Begin add-new-plant modal window-->

    <!--Begin create-package-from-batch modal-window-->
    <CreatePackageFromPlantBatch ref="createPackage" @showSuccessMsg="displaySuccessMsg"></CreatePackageFromPlantBatch>
    <!--End create-package-from-batch modal-window-->
    
    <!--Begin DestroyPlantBatch modal-window-->
    <DestroyPlantBatch ref="destroyPlantbatch" @showSuccessMsg="displaySuccessMsg" @loadPlantBatch="fetch"></DestroyPlantBatch>
    <!--End DestroyPlantBatch modal-window-->
    
    <!--Begin add_plant_batch modal-window-->
    <AddPlantBatch ref="addPlantbatch" @showSuccessMsg="displaySuccessMsg" @loadPlantBatch="fetch"></AddPlantBatch>
    <!--End add_plant_batch modal-window-->
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import Navigation from '@/components/Navigation';
import AddPlant from '@/components/modals/AddPlant';
import CreatePackageFromPlantBatch from '@/components/modals/CreatePackageFromPlantBatch';
import DestroyPlantBatch from '@/components/modals/DestroyPlantBatch';
import AddPlantBatch from '@/components/modals/AddPlantBatch';
import AlertMessageModal from '@/components/AlertMessageModal';
import $ from 'jquery';
import * as select2 from 'select2/dist/js/select2.full.js';
import 'select2/dist/css/select2.min.css';

Vue.use(VueSpinners);

export default {
  name: 'PlantbatchOverview',
  data() {
    return {
      plantBatches: [],
      isTableEnabled: false,
      showLoader: false
    };
  },
  components: {
    Navigation,
    AlertMessageModal,
    HashLoader,
    AddPlant,
    CreatePackageFromPlantBatch,
    DestroyPlantBatch,
    AddPlantBatch
  },
  created() {
    this.fetch(false);
    this.removeFile('/static/js/oneui.app.min.js', 'js');
    this.removeFile('/static/js/be_tables_datatables.min.js', 'js');
    this.loadFile('/static/js/oneui.app.min.js', 'js');  
    this.loadFile('/static/js/be_tables_datatables.min.js', 'js');
  },
  computed: {
    ...mapState({
      library: state => state.library
    }),
    getBatchEntries() {
      if (this.$store.state.library.plantBatches.length) {
        return this.enableDataTable(this.$store.state.library.plantBatches);
      }
    }
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['getAllPlantBatches']),
    ...mapGetters('library', ['getPlantBatches']),
    async fetch(force) {
      if (force || this.getPlantBatches().length === 0) {
        this.showLoader = true;
        await this.getAllPlantBatches();
      }
      if (this.getPlantBatches().length === 0) {
        this.enableDataTable([]);
      }
    },
    enableDataTable(data) {
      let vm = this, table;
      vm.showLoader = true;
      if (vm.isTableEnabled) {
        table = jQuery('#plantbatch-table').DataTable();
        table.destroy();
      }
      vm.plantBatches = data;
      vm.prepareDataTable('#plantbatch-table');
      vm.isTableEnabled = true;
      vm.showLoader = false;
    },
    showAddPlantModal(plantBatchName) {
      this.$refs.addPlant.setPlantBatchName(plantBatchName);
      jQuery('#add-new-plant').modal('show');
    },
    showCreatePackageModal(plantBatch) {
      this.$refs.createPackage.setPlantBatchDetails(plantBatch);
      jQuery('#create-package-from-batch').modal('show');
    },
    showDestroyModal(batchName) {
      this.$refs.destroyPlantbatch.setPlantBatchName(batchName);
      jQuery('#destroy-plant-batch').modal('show');
    },
    displaySuccessMsg(message) {
      this.success(message);
      this.triggerMessageModal('#alert_modal');
    },
    showAddPlantBatchModal() {
      jQuery('#add_plant_batch').modal('show');
    }
  },
  mounted() {
    $('.select2-dropdown').each(function(){
      $(this).select2({
        dropdownParent: $(this).parent(),
        placeholder: $(this).attr('placeholder')
      });
    });
  },
  beforeDestory() {
    this.removeFile('/static/js/oneui.app.min.js', 'js');
    this.removeFile('/static/js/be_tables_datatables.min.js', 'js');
  }
};
</script>

<style>
.bg-light {
  background: #9eb89f !important;
}
.table-overview table button {
  margin-bottom: 5px;
}
.table-overview table {
  width: 900px; 
}
.table-overview > div {
  overflow: auto;
}
.table-overlay .block {
  position: relative;
}
.table-overlay .block-header {
  flex-direction: column;
  text-align: center;
}
.action {
  margin: 0 auto;
}
@media only screen and  (min-width: 992px){
  .table-overview > div {
    overflow: initial;
  }
  .table-overview table {
    width: 100%; 
  }
}
@media only screen and  (min-width: 767px){
  .table-overlay .block-header {
    flex-direction: row;
    text-align: left;
  }
}
</style>


// WEBPACK FOOTER //
// source/components/PlantBatchOverview.vue